"use client";
import SvgAutoriaSymbol from "./autoria_symbol.svg.js";
import SvgAutoriaWordmark from "./autoria_wordmark.svg.js";
const autoria = {
  key: "autoria",
  symbol: SvgAutoriaSymbol,
  wordmark: SvgAutoriaWordmark
};
export {
  autoria
};
